export default __webpack_public_path__ + "static/media/Again.ad8a18d1.mp3";